import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/css/reset.css";
import "./assets/css/global.less";
import { Swipe, SwipeItem, Popup,ShareSheet } from "vant";
import AntDesign from './plugins/ant-design'
import { ActionSheet } from 'vant';
import { Cell, CellGroup } from 'vant';
import { Toast } from "vant";
import { ContactEdit } from 'vant';
import { Field } from 'vant';
import { Form } from 'vant';
import { Picker } from 'vant';
import { Button } from 'vant';
import { DatetimePicker } from 'vant';
import { Calendar } from 'vant';
import { Icon } from 'vant';
import { Dialog } from 'vant';
import { NoticeBar, Overlay, Image as VanImage, CountDown } from 'vant';
import { Uploader } from 'vant';

const app = createApp(App);
// 全局注册
app.use(NoticeBar);
app.use(Swipe);
app.use(Dialog);
app.use(Icon);
app.use(Calendar);
app.use(DatetimePicker);
app.use(Picker);
app.use(Button);
app.use(Popup);
app.use(Form);
app.use(Field);
app.use(ContactEdit);
app.use(ActionSheet);
app.use(Cell);
app.use(CellGroup);
app.use(Toast);
app.use(Popup);
app.use(ShareSheet);
app.use(SwipeItem);
app.use(router);
app.use(AntDesign);
app.use(Overlay);
app.use(VanImage);
app.use(CountDown);
app.use(Uploader);

app.mount("#app");

